import React, { useEffect, useState, useMemo } from 'react';
import PopAdminPresenter from "../../../presenters/screens/pop-admin.presenter";
import DropDownOptions, { Lookup } from 'devextreme-react/lookup';
import { Row, Col } from 'reactstrap';
import Step1 from './step1/Step1';
import Step2 from './step2/Step2';
import Step3 from './step3/Step3';
import StepSDC from './stepSDC/StepSDC';
import Step4 from './step4/Step4';
import ModalFollowup from './modal-followup/modal-followup';
import { IPopAdmin } from "@interfaces/screens/pop-admin.interface";
import {Modal, ModalHeader, ModalBody } from 'reactstrap';

const PopAdmin: React.FC = () => {
    const [projects, setProjects] = useState<any>([]);
    const [stepsData, setStepsData] = useState<any>(null);
    const [subprojects, setSubProjects] = useState<any>([]);
    const [details, setDetails] = useState<any>([]);
    const [projectSelected, setProjectSelected] = useState<any>(null);
    const [subProjectSelected, setSubProjectSelected] = useState<any>(null);
    const [columns, setColumns] = useState<any>({FFRR: null, FFEE: null});
    const [columnsModal, setColumnsModal] = useState<any>({ind: null, ben: null, fin: null});
    const [endProcess, setEndProcess] = useState<any>(false);

    const view: IPopAdmin = {
        state: {
            projectSelected,
            subProjectSelected,
            details,
            columns,
            setDetails,
            setProjects,
            setSubProjects,
            setProjectSelected,
            setSubProjectSelected,
            setColumns,
            setColumnsModal,
            setStepsData
        },
    };
      
    const presenter = new PopAdminPresenter(view);

    const hasPermission = useMemo(() => 
        presenter.getAdminPermissions(),
        [presenter.currentUser, presenter.params]
    )

    const UserPermission = useMemo(() => 
        presenter.getUserPermissions(),
        [presenter.currentUser]
    )
    
    useEffect(() => {
        presenter.initialize();
    }, []);

    useEffect(() => {
        if(presenter.finishAlert && !presenter.stepsData && !presenter.followUpData){
            setEndProcess(true)
        }else if(endProcess && !!presenter.stepsData && !!presenter.followUpData){
            setEndProcess(false)
            presenter.onSubProjectChanged(null, true)
            presenter.showFinishAlert()
        }
    }, [presenter.stepsData, presenter.followUpData, presenter.finishAlert]);

    useEffect(() => {
        if(!!presenter.allBudgetDetails && !!presenter.allBudgets) presenter.getProjects();
    }, [presenter.allBudgets, presenter.allBudgetDetails]);

    useEffect(() => {
        if(!!projects?.length && !!presenter.formMasters && !!presenter.formMastersFollowup && presenter.currentLabels?.values?.length !== 0 && !!presenter.currentLabels &&
            !!presenter.followUpData && !!presenter.stepsData && !!presenter.allBudgets && !!presenter.allBudgetDetails && !!columns.FFRR && !!columns.FFRR &&
            presenter.followupLabels?.values?.length !== 0 && !!presenter.followupLabels){
            presenter.unSetLoading();
        }
    }, [projects, presenter.formMasters, presenter.currentLabels, presenter.followUpData]);

    if(!hasPermission) return <h2 style={{color:"red", padding:"1rem"}}>{presenter.followupLabels.get('adminPermissionRequired')}</h2>

    if((!projects?.length || !presenter.formMasters || presenter.currentLabels?.values?.length === 0 || !columns.FFRR || !columns.FFRR || !presenter.formMastersFollowup ||
        !presenter.currentLabels || !presenter.followUpData || !presenter.stepsData || !presenter.allBudgets || !presenter.allBudgetDetails ||
        !presenter.followupLabels || presenter.followupLabels?.values?.length === 0) && !presenter.finishAlert){
        return <></>
    } 

    const onClose = () => { presenter.onCloseModal() }

    return (
        <div style={{margin: '30px 0'}}>
            <Row xs="4" sm="4" md="4" lg="4" xl="4">
                <Col>
                    <div className="dx-fieldset-header">{presenter.currentLabels.get("AdminPopProjects")}</div>
                    <div className="dx-field">
                        <Lookup
                            value={projectSelected}
                            items={projects}
                            defaultValue={projects[0]}
                            onValueChanged={presenter.onProjectChanged}
                        >
                        <DropDownOptions />
                        </Lookup>
                    </div>
                </Col>
                {!!subprojects?.length && <Col>
                    <div className="dx-fieldset-header">{presenter.currentLabels.get("AdminPopSubProjects")}</div>
                    <div className="dx-field">
                        <Lookup
                            value={subProjectSelected}
                            items={subprojects}                                    
                            displayExpr={presenter.getDisplayExpression}
                            onValueChanged={presenter.onSubProjectChanged}
                        >
                        <DropDownOptions />
                        </Lookup>
                    </div></Col>
                }
            </Row>
            
            {(columns.FFRR && columns.FFRR && !!stepsData) &&
                < div style={{margin: '30px 0'}}>
                    <Step1 columns={columns.FFRR} data={stepsData?.step1} />
                    <Step2 columns={columns.FFRR} data={stepsData?.step2}  />
                    <StepSDC columns={columns.FFRR} data={stepsData?.stepSDC} />
                    <Step3 columns={columns.FFRR} data={stepsData?.step3} />
                    <Step4 columns={columns.FFEE} data={stepsData?.step4} />
                </div>
            }

            <Modal size='xl' isOpen={presenter.openModal} centered toggle={onClose}>
                <ModalHeader toggle={onClose}></ModalHeader>
                <ModalBody >
                    { presenter.openModal && <ModalFollowup stepsData={stepsData} columns={columnsModal} /> }
                </ModalBody>
            </Modal>
        </div>
    )
}

export default PopAdmin;